/* eslint-disable sort-imports */
import {
  Listing,
  ListingCancellationPolicy,
  ListingContractType,
  ListingCostsCosts,
  ListingFacilities,
  ListingPricingType,
  ListingPricingValues,
} from 'ha/services/apiV2/types/Listing';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { RequiredDocumentsFormValues } from './types/RequiredDocuments';

export interface UpdateListingPayload {
  address?: string;
  structuredAddress?: {
    countryCode: string;
    city: string;
    postalCode: string;
    street: string;
    houseNumber?: string;
    aptNumber?: string;
  };
  kind?: number;
  type?: number;
  description?: string;
  alias?: string;
  currency?: string;
  price?: number | null;
  minimumStayMonths?: number;
  maxBookableDays?: number;
  currentOccupancy?: number;
  freePlaces?: number | null;
  minAge?: number;
  maxAge?: number;
  preferredGender?: string;
  isInstantAllowed?: boolean;
  facilities?: ListingFacilities;
  how?: string;
  icsUrl?: string;
  costs?: ListingCostsCosts;
  contractType?: ListingContractType;
  cancellationPolicy?: ListingCancellationPolicy;
  pricingType?: ListingPricingType;
  pricingValues?: ListingPricingValues;
}

export interface UpdateListingPayloadWithRequirements
  extends UpdateListingPayload {
  requiredDocuments?: RequiredDocumentsFormValues;
}

interface Query {
  /**
   * @description comma-separated string with possible values: `exclusions`, `exclusionsExtended`, `bookablePeriods`, `conversationCounters`, `lastMonthConversationCount`, `videos`, `costs`
   */
  expand?: string;
  withPhotos?: string;
  withCroppedPhotos?: boolean;
  lang?: string;
}

export default (makeCall: MakeCall) =>
  (listingId: number, data: UpdateListingPayload, query?: Query) =>
    makeCall<Listing>('PUT', `/api/v2/listing/${listingId}`, {
      data,
      query,
    });
